import { wfetch } from "../../utils/fetch";
import { getApiEndpoint } from "../../utils/constants/api";

export const FETCH_SITE = "FETCH_SITE";

/**
 * Fetches site info from Magnolia (includes i18n settings).
 * @param {string} nodePath - The node path to get site info for.
 * @param {string} workspace - The workspace the node lives in.
 * @returns {Promise<object|null>} The site info JSON or null on error.
 */
export const fetchSite = (nodePath, workspace = "website") => {
    return async (dispatch) => {
        const response = await wfetch(getApiEndpoint("SITE_INFO", { pathParams: { workspace, path: nodePath } }));

        if (!response) return;

        dispatch({
            type: FETCH_SITE,
            payload: response.data,
        });
    };
};
